import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Gift } from 'lucide-react';
import { bonuses } from '../data/bonuses';
export function BonusSection() {
  return <section className="py-24 px-4 bg-white border-y border-slate-200" data-id="element-19" data-mp="22fmv4tjdi00j">
      <div className="max-w-5xl mx-auto" data-id="element-20" data-mp="22divwowf5p6l">
        <div className="text-center mb-16" data-id="element-21" data-mp="1ydi7qcjipzmc">
          <p className="text-[#0A6464] font-bold tracking-widest uppercase mb-2" data-id="element-22" data-mp="1yet9k6tekxat">
            Included With Your Purchase at No Additional Cost
          </p>
          <h2 className="text-4xl md:text-5xl font-bold tracking-tight text-[#0F4C5C]" data-id="element-23" data-mp="15pw10vezuev9">
            <span className="text-[#0B7A7A]" data-id="element-24" data-mp="1jgitw6y2pajf">5</span> EXCLUSIVE DENTAL{' '}
            <span className="text-[#0B7A7A]" data-id="element-25" data-mp="1jilshfdakbzr">INSTRUCTOR BONUSES</span>
          </h2>
          <p className="text-lg text-slate-700/80 max-w-3xl mx-auto mt-5" data-id="element-26" data-mp="1enxzb37ceteu">
            The six main volumes give you visual training material for every core dental teaching area. And the
            five bonuses add practical tools to help you drill tooth identification, script your clinical
            demonstrations, run typodont and simulation lab drills, train radiograph interpretation, and assess
            students with clear competency rubrics and certificates.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-27" data-mp="2jjzcnnztt5vr">
          {bonuses.map((bonus, index) => <motion.article key={bonus.id} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className={`bg-white border border-slate-200 rounded-2xl p-8 shadow-sm shadow-[#0F4C5C]/5 relative flex flex-col ${index === 4 ? 'md:col-span-2' : ''}`} data-id="element-28" data-mp="2oj26ecacvpof" data-mpi={index}>
              <div className="absolute top-0 right-0 bg-[#0F4C5C] text-white px-4 py-2 rounded-bl-2xl rounded-tr-2xl font-bold text-sm" data-id="element-29" data-mp="3c8o5kzqqa4wf">
                BONUS {bonus.id}
              </div>
              <div className="w-12 h-12 bg-[#E3EFF1] border border-[#A7B7C1] rounded-full flex items-center justify-center text-[#0B7A7A] mb-4" data-id="element-30" data-mp="1h1kf649q34ye">
                <Gift size={24} data-id="element-31" data-mp="1q3trmzojx8ef" />
              </div>
              <h3 className="text-xl font-bold tracking-tight mb-2 pr-28 text-[#0F4C5C]" data-id="element-32" data-mp="1q3ah4418dmaf">{bonus.title}</h3>
              <p className="text-[#0A6464] text-sm font-semibold mb-4 border-l-4 border-[#0B7A7A] pl-4" data-id="element-33" data-mp="1m0dtu00qx205">
                {bonus.subtitle}
              </p>
              {bonus.referenceValueCents !== undefined && <p className="flex flex-wrap items-baseline gap-x-2 text-sm mb-4" data-id="element-34" data-mp="1757m98m04v4p">
                  <span className="text-slate-500" data-id="element-35" data-mp="177c1gmpcpgka">Reference value:</span>
                  <span className="text-slate-500 line-through" data-id="element-36" data-mp="12cy0m4rx6h88">
                    {formatUsd(bonus.referenceValueCents)}
                  </span>
                  <span className="font-extrabold text-[#0A6464] uppercase tracking-wide" data-id="element-37" data-mp="anl4evvfgpn9">
                    Included free
                  </span>
                </p>}
              {bonus.intro && <p className="text-slate-700 text-sm mb-4 leading-relaxed" data-id="element-38" data-mp="5amnkl0euz1s">{bonus.intro}</p>}

              {bonus.bullets && <>
                  <p className="text-[#0F4C5C] font-semibold text-sm mb-3" data-id="element-39" data-mp="3morw96b9bgde">{bonus.bulletsIntro}</p>
                  <ul className={`mb-6 ${bonus.bullets.length > 8 ? 'grid sm:grid-cols-2 gap-x-4 gap-y-2' : 'space-y-2'} ${index === 4 ? 'md:grid-cols-4' : ''}`} data-id="element-40" data-mp="3rncvb2ervu09">
                    {bonus.bullets.map(bullet => <li key={bullet} className="flex items-start gap-3" data-id="element-41" data-mp="9e2ovunfdnkt">
                        <CheckCircle2 size={16} className="text-[#0B7A7A] shrink-0 mt-0.5" data-id="element-42" data-mp="e8yg4sku86wv" />
                        <span className="text-slate-700 text-sm" data-id="element-43" data-mp="2u0dzetvwmq3f">{bullet}</span>
                      </li>)}
                  </ul>
                </>}

              {bonus.detailedBullets && <>
                  <p className="text-[#0F4C5C] font-semibold text-sm mb-3" data-id="element-44" data-mp="3ahpz3ambdjrw">{bonus.bulletsIntro}</p>
                  <ul className="mb-6 space-y-3" data-id="element-45" data-mp="35i3mn3eb87k5">
                    {bonus.detailedBullets.map(item => <li key={item.title} className="flex items-start gap-3" data-id="element-46" data-mp="30k1vdv6qd1xl">
                        <CheckCircle2 size={16} className="text-[#0B7A7A] shrink-0 mt-0.5" data-id="element-47" data-mp="21d3rnxmq011" />
                        <div data-id="element-48" data-mp="3t7xz3jupvu3v">
                          <span className="block text-[#0F4C5C] font-bold text-sm" data-id="element-49" data-mp="3t7o5znedl6ty">{item.title}</span>
                          <span className="block text-slate-700 text-sm" data-id="element-50" data-mp="3o7tjdw1mv3ep">{item.detail}</span>
                        </div>
                      </li>)}
                  </ul>
                </>}

              {bonus.secondaryBullets && <>
                  <p className="text-[#0F4C5C] font-semibold text-sm mb-3" data-id="element-51" data-mp="27uboo77fh2bi">
                    {bonus.secondaryBulletsIntro}
                  </p>
                  <ul className="mb-6 grid sm:grid-cols-2 gap-x-4 gap-y-2" data-id="element-52" data-mp="nahg9yiatqvw">
                    {bonus.secondaryBullets.map(bullet => <li key={bullet} className="text-[#0F4C5C] font-semibold text-sm bg-[#E3EFF1] border border-[#CFE0E4] rounded-lg px-3 py-2" data-id="element-53" data-mp="xa89lwv4hzue">
                        {bullet}
                      </li>)}
                  </ul>
                  {bonus.secondaryNote && <p className="-mt-3 mb-6 text-slate-700 text-sm italic" data-id="element-54" data-mp="1b3znfhfw05vx">{bonus.secondaryNote}</p>}
                </>}

              <div className="mt-auto space-y-3" data-id="element-55" data-mp="1kyzwc8py1pzs">
                {bonus.system && <div data-id="element-56" data-mp="3hte3m591h8sw">
                    <p className="text-[#0F4C5C] font-semibold text-sm mb-2" data-id="element-57" data-mp="3hu5tczfygcb9">{bonus.systemLabel}</p>
                    <p className="text-[#0F4C5C] font-bold text-xs sm:text-sm tracking-wide bg-[#E3EFF1] border-l-4 border-[#0B7A7A] rounded-lg px-3 py-2" data-id="element-58" data-mp="3ms7ju5fpndwr">
                      {bonus.system}
                    </p>
                  </div>}
                {bonus.result && <div className="bg-[#F2F7F8] border border-[#CFE0E4] border-l-4 border-l-[#0F4C5C] rounded-xl p-4" data-id="element-59" data-mp="3oqqtmoq9c0n8">
                    <span className="text-[#0F4C5C] font-bold block mb-1" data-id="element-60" data-mp="3js5t0o73fey9">RESULT</span>
                    <p className="text-slate-700 text-sm" data-id="element-61" data-mp="1iwsar2c983a">{bonus.result}</p>
                  </div>}
                {bonus.closing && <div className="pt-4 border-t border-slate-200" data-id="element-62" data-mp="bast49vt7cb7">
                    {bonus.closing.map((line, lineIndex) => <p key={line} className={lineIndex === 0 ? 'text-[#0F4C5C] font-extrabold text-base tracking-wide' : 'text-[#0F4C5C] font-semibold text-sm italic'} data-id="element-63" data-mp="6chjo09ff3ti" data-mpi={lineIndex}>
                        {line}
                      </p>)}
                  </div>}
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}
function formatUsd(cents: number): string {
  return `$${(cents / 100).toFixed(2)} USD`;
}